import React from "react";
import IMG1 from "../../assets/projects/gpt.png";
import IMG2 from "../../assets/projects/curd.png";
import IMG3 from "../../assets/projects/google.png";
import IMG4 from "../../assets//projects/weeb.png";
import IMG5 from "../../assets/projects/movie.png";
import IMG6 from "../../assets/projects/rtrex.png";
import IMG7 from "../../assets/projects/sign.jpg";
import IMG8 from "../../assets/projects/bic.png";
import IMG9 from "../../assets/projects/macun.png";
import IMG10 from "../../assets/projects/calculator.png";
import Inventory from "../../assets/projects/inventory.png";
import ProductPreviewCard from "../../assets/projects/productpreview.png";
import InteractiveRating from "../../assets/projects/interactiverating.png";
import Revolutions from "../../assets/projects/revolutions.png";
import Gemeinden from "../../assets/projects/gemeinden.webp";

import "./portfolio.css";

const Portfolio = () => {
  const soloProjects = [
    {
      id: 1,
      title: "Inventory and Employee managment system",
      img: Inventory,
      description:
        "Inventory and Employee managment system built using React, Node and MySQL.",
      technologies: "React | Node.js | MySQL",
      github: "https://github.com/adzaa/zalihe-backend",
    },
    {
      id: 1,
      title: "WordPress Website",
      img: Revolutions,
      description: "Interactive wordpress website with animations.",
      technologies: "WordPress | Javascript",
      link: "https://revolutions.de/",
    },
    {
      id: 1,
      title: "Gemeinden App",
      description:
        "App where you connect with your city and where you can see latest news and events.",
      technologies: "React Native | Node JS",
      link: "https://apps.apple.com/ua/app/gemeinden-app/id6476973421?platform=iphone",
    },
    {
      id: 1,
      title: "Interactive Rating Component",
      img: InteractiveRating,
      description:
        "Users should be able to See hover states for all interactive elements on the page Select and submit a number rating. See the Thank you card state after submitting a rating.",

      technologies: "HTML | CSS | JavaScript",
      link: "https://adzaa.github.io/interactive-rating-component-main/",
      github: "https://github.com/adzaa/interactive-rating-component-main",
    },
    {
      id: 1,
      title: "GPT-3",
      img: IMG1,
      description: "Modern Responsive UI/UX Website in React JS",
      technologies: "React",
      link: "https://reactprojectadza.netlify.app",
      github: "https://github.com/adzaa/gpt3react",
    },
    {
      id: 2,
      title: "MacunMed.ba",
      img: IMG9,
      description: "Product Landing Page",
      technologies: "JavaScript | HTML | CSS | BootStrap",
      link: "https://macun-med.ba/",
    },
    {
      id: 2,
      title: "Product Preview Card Component",
      img: ProductPreviewCard,
      description:
        "Users should be able to: View the optimal layout depending on their device's screen size. See hover and focus states for interactive elements.",
      technologies: "HTML | CSS ",
      link: "https://adzaa.github.io/Product-preview-card-component/",
      github: "https://github.com/adzaa/Product-preview-card-component",
    },
    {
      id: 3,
      title: "Wordpress Blog Web App",
      img: IMG4,
      description: "Wordpress blog web application",
      technologies: "Wordpress",
      link: "https://weebdegeneracysquad.com",
    },
    {
      id: 4,
      title: "Calculator",
      img: IMG10,
      description: "Simple Calculator",
      technologies: "HTML | CSS | JavaScript",
      link: "https://abdulah-calculator.netlify.app/",
      github: "https://github.com/adzaa/kalkulator",
    },
    {
      id: 5,
      title: "CURD-App",
      img: IMG2,
      description: "CURD App built with REACT",
      technologies: "React",
      link: "https://crudabdulah.netlify.app",
      github: "https://github.com/adzaa/crud_app/",
    },
    {
      id: 6,
      title: "Google Clone",
      img: IMG3,
      description: "Google Clone built with html&css",
      technologies: "HTML | CSS",
      link: "https://abdulah-google-clone.netlify.app",
      github: "https://github.com/adzaa/google_clone",
    },
    {
      id: 7,
      title: "Movie Search App",
      img: IMG5,
      description: "React Movie App project with React and the OMBD API",
      technologies: "React",
      link: "https://wizardly-noyce-dd261e.netlify.app",
      github: "https://github.com/adzaa/codepool1",
    },
    {
      id: 8,
      title: "Landing Page",
      img: IMG6,
      description: "Simple Landing Page",
      technologies: "JavaScript | HTML | CSS | BootStrap",
      link: "https://trextea.ba",
    },
    {
      id: 9,
      title: "BIC-Chat",
      img: IMG8,
      description:
        "With Direct and Group Chats, emojis & Reactions, Built-in Gif support, the ability to edit & delete messages, specialized commands, and much more.",
      technologies: "React",
      link: "https://bic-chat.netlify.app",
      github: "https://github.com/adzaa/BIC-Chat",
    },
    {
      id: 10,
      title: "Sign in Page",
      img: IMG7,
      description:
        "This sign-in page is a great example of an effective and minimalist design. It focuses on the benefits that provide to users and doesn’t bombard them with information.",
      technologies: "HTML | CSS | BootStrap",
      link: "https://signinui.netlify.app",
      github: "https://github.com/adzaa/SignIn",
    },
  ];

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {soloProjects.map((pro) => (
          <article className="portfolio__item" key={pro.id}>
            <div className="portfolio__item-image">
              <img src={pro.img} alt={pro.title} />
            </div>
            <div className="portfolio__item-content">
              <h3>{pro.title}</h3>
              <p>{pro.description}</p>
              <p>{pro.technologies}</p>
            </div>
            <div className="portfolio__item-cta">
              {pro.github && pro.github.length > 0 && (
                <a
                  href={pro.github}
                  target="_blank"
                  className="btn"
                  rel="noreferrer"
                >
                  GitHub
                </a>
              )}

              <a
                href={pro.link}
                target="_blank"
                className="btn btn-primary"
                rel="noreferrer"
              >
                Visit Website
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
